import React, { useEffect, useState } from 'react' 
import {ILayoutBodyProps} from '@libs/interfaces/layouts' 
import LayoutBodyLocal from './LayoutBodyLocal'
import actions from 'src/modules/pe-basic-module/data/actions'
import { USER_INFO_ACTION} from '@/modules/pe-basic-module/data/actionTypes'
import { Loading } from '@libs/useful'
import { IState, useMainStore } from '@/settings/zustand'


const LayoutBodyStatic = (props: ILayoutBodyProps) => {
  const token: string | null = useMainStore((state:IState) => state.accessToken)   
  const [isLoading, setIsLoading] = useState(true) 
    useEffect(() => {  
      if( token ) {  
        actions(USER_INFO_ACTION, {}).finally(() => setIsLoading(false))
      }
      else {
        setIsLoading(false)
      }
    }, [])
    if( isLoading ) {
      return <div className="layout-state flex-centered w-100 h-100"><Loading /></div>
    } 
    return  <LayoutBodyLocal {...props} />  
}
 

export default LayoutBodyStatic